import React from 'react';
import 'crypto-js/lib-typedarrays';
import { Auth } from 'aws-amplify';
import { Button, Form, Input, notification, Badge } from "antd";
import { connect } from "react-redux";
//import {Link} from "react-router-dom";
import { userSignInAws, ActionSingUp } from "../appRedux/actions/Auth";
import awsExports from "./aws-exports";
import SignUp from "./SignUp";
import IntlMessages from "util/IntlMessages";
import InfoView from "components/InfoView";

Auth.configure(awsExports);

const FormItem = Form.Item;

class SignInCognito extends React.Component {

  state = {
    code: '',
    sms: false,
    forget_password: false,
    forget_password_send_email: false,
    email: '',
    new_user: false,
    new_password: '',
    confirmDirty: false,
    yztime: 59,
    resend: true,
    password: '',
    username: '',
    signup_visible: false,
  }
  
  componentDidMount = () => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
   
      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
   
      if (isScriptExist && callback) callback();
    }
    loadScriptByURL("recaptcha-key", 'https://www.google.com/recaptcha/api.js?render='+process.env.REACT_APP_RECAPTCHA_SITEKEY, function () {

    });
  }

  // componentWillUnmount = () => {
  //   document.querySelector("#recaptcha-key").remove()
  // }

  handleSubmit = (e) => {
    const { userSignInAws } = this.props
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        let username = values.username
        let password = values.password

        this.setState({ loading: true, username: username, password: password });
        this.props.form.resetFields();
        Auth.signIn(username, password)
          .then(user => {

            if (user.challengeName === 'SMS_MFA' ||
              user.challengeName === 'SOFTWARE_TOKEN_MFA') {
              //this.ConfirmSignIn(user, user.challengeName)
              this.setState({
                sms: true,
                user: user,
                challengeName: user.challengeName
              })
              this.countDown()
            } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
              this.setState({
                new_user: true,
                user: user,
              })

              notification.success({
                message: 'Succesfully log in!',
                description: 'Please set up the new password.',
                placement: 'topRight',
                duration: 1.5
              });
            } else if (user.challengeName === 'MFA_SETUP') {

            }
            else {
              userSignInAws(user.signInUserSession)

              notification.success({
                message: 'Succesfully logged in!',
                description: 'Logged in successfully!',
                placement: 'topRight',
                duration: 1.5
              });
            }
            // history.push(from);
          })
          .catch(err => {
            // Force reset password
            switch (err.code) {
              case 'PasswordResetRequiredException':
                this.setState({
                  sms: false,
                  forget_password: true,
                  forget_password_send_email: true
                });
                notification.error({
                  message: 'Error',
                  description: err.message,
                  placement: 'topRight'
                });
                break;
              default:
                notification.error({
                  message: 'Error',
                  description: err.message,
                  placement: 'topRight'
                });
            }

            this.setState({ loading: false });
          });
      }
    });
  };

  componentDidUpdate = () => {
    //console.log(this.props.access_token)
    if (this.props.access_token !== null) {
      this.props.history.push('/');
      if(document.querySelector("#recaptcha-key")){
        document.querySelector("#recaptcha-key").remove()
      }
      if(document.querySelector(".grecaptcha-badge")){
        document.querySelector(".grecaptcha-badge").remove()
      }
    }
  }

  SubmitSms = (e) => {
    const { userSignInAws, form } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let code = values.code
        form.resetFields();
        Auth.confirmSignIn(
          this.state.user,   // Return object from Auth.signIn()
          code,   // Confirmation code  
          this.state.challengeName // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
        ).then(user => {
          userSignInAws(user.signInUserSession)
          notification.success({
            message: 'Succesfully logged in!',
            description: 'Logged in successfully!',
            placement: 'topRight',
            duration: 1.5
          });
        }).catch(err => {
          notification.error({
            message: 'Error',
            description: err.message,
            placement: 'topRight'
          });

          console.log(err);

          this.setState({ loading: false, sms: false });
        });
      }
    })

  }

  handleForgetPassword = () => {
    this.setState({
      forget_password: true,
      forget_password_send_email: false,
    })
  }

  SubmitUserEmail = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let email = values.email

        Auth.forgotPassword(email)
          .then(data => console.log(data))
          .catch(err => console.log(err));

        this.props.form.resetFields();
      }
    })

    this.setState({
      forget_password_send_email: true
    })
  }

  handleSubmitResetPassword = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let username = values.username
        let new_password = values.password
        let code = values.code
        this.props.form.resetFields();
        Auth.forgotPasswordSubmit(username, code, new_password)
          .then(data => {
            this.setState({
              forget_password: false,
              forget_password_send_email: false
            })
          })
          .catch(err => console.log(err));
      }
    })
  }

  handleSubmitNewPassword = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let user = this.state.user
        let new_password = values.password
        this.props.form.resetFields();
        Auth.completeNewPassword(user, new_password)
          .then(data => {
            if (data.challengeName === "SMS_MFA") {
              this.setState({
                new_user: false,
                sms: true,
              })
              this.countDown()
            }
            else {
              this.setState({
                new_user: false
              })
              window.location.reload()
            }
          })
          .catch(err => console.log(err));

        notification.success({
          message: 'Password reset',
          description: 'Password reset successful',
          placement: 'topRight',
          duration: 1.5
        });

      }
    })

  }

  ReturnSignIn = () => {
    this.setState({
      forget_password: false
    })
  }

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    if (!this.ValidPassword(value)) {
      callback(this.valid(value));
    }
    callback();
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords are inconsistent!');
    } else {
      callback();
    }
  };

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  valid = (value) => {
    // eslint-disable-next-line
    var format_cha = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    var format_low = /[a-z]/
    var format_up = /[A-Z]/
    return (<div>
      <Badge status={value.length >= 8 ? 'success' : 'error'} text="Password minimum length 8" />
      <Badge status={format_cha.test(value) ? 'success' : 'error'} text="Password must contain special character" />
      <Badge status={format_low.test(value) ? 'success' : 'error'} text="Password must contain uppercase letters" />
      <Badge status={format_up.test(value) ? 'success' : 'error'} text="Password must contain lowercase letters" />
    </div>)
  }

  ValidPassword = (value) => {
    // eslint-disable-next-line
    var format_cha = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    var format_low = /[a-z]/
    var format_up = /[A-Z]/
    if (value.length < 8) {
      this.setState({
        password_length: false
      })
      return false
    } else if (!format_cha.test(value)) {
      return false
    } else if (!format_low.test(value)) {
      return false
    } else if (!format_up.test(value)) {
      return false
    }
    return true
  }

  ResendConfirmationCode = () => {
    this.countDown()
    this.setState({
      resend: true
    })
    try {
      Auth.signIn(this.state.username, this.state.password)
        .then(user => this.setState({
          user: user
        }))

      notification.success({
        message: 'Multi-factor Authentication',
        description: 'Please check your sms',
        placement: 'topRight',
        duration: 1.5
      });

      this.setState({
        username: '',
        password: '',
        user: null,
      })
    } catch (err) {
      console.log('error resending code: ', err);
    }
  }

  countDown = () => {
    let { yztime } = this.state;
    let siv = setInterval(() => {
      this.setState({ yztime: (yztime--) }, () => {
        if (yztime <= -1) {
          clearInterval(siv);
          this.setState({ resend: false, yztime: 59 })
        }
      });
    }, 1000);
  }

  handleSignUp = () => {
    this.setState({
      signup_visible: true,
    })
  }

  CloseSignUp = () => {
    this.setState({
      signup_visible: false,
    })
  }

  SubmitSignUp = () => {
    const { form } = this.signUpFormRef.props;
    const { ActionSingUp } = this.props
    const vm = this
    window.grecaptcha.ready(function() {
      window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_SITEKEY, {action: 'submit'}).then(function(token) {
        form.validateFields((err, values) => {

          if (err) {
            return;
          }
          let phone = values.phone
          if (phone.length === 12) {
            phone = '+' + values.phone.substring(0, 2) + values.phone.substring(3)
          } else {
            phone = '+' + values.phone
          }
          values.phone = phone
          values.token = token
    
          ActionSingUp(values)
    
          form.resetFields();
    
          vm.setState({ signup_visible: false });
        });
      });
    });
    
  }

  wrapSignUpFormRef = formRef => {
    this.signUpFormRef = formRef;
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
        <div className="gx-app-login-wrap">
          <div className="gx-app-login-container">
            <div className="gx-app-login-main-content">
              <div className="gx-app-logo-content">
                <div className="gx-app-logo-content-bg">
                </div>
                <div className="gx-app-logo-wid">
                  <h1>{this.state.new_user === true ? 'Set your password'
                    : this.state.forget_password === false ? 'Sign In'
                      : this.state.sms === false && this.state.forget_password === true && this.state.forget_password_send_email === true ? 'Reset Password'
                        : 'Forgotten Password'}</h1>
                  <p><IntlMessages id="app.userAuth.welcome" /></p>
                </div>
              </div>
              <div className="gx-app-login-content">
                {//new user first log in 
                  this.state.new_user === true ?
                    <Form onSubmit={this.handleSubmitNewPassword} className="gx-signin-form gx-form-row0" autoComplete="off">
                      <FormItem>
                        {getFieldDecorator('password', {
                          rules: [
                            {
                              required: true, message: 'Please input your Password!'
                            },
                            {
                              validator: this.validateToNextPassword,
                            },],
                        })(
                          <Input type="password" placeholder="New Password" autoComplete="new-password" name="password" />
                        )}
                      </FormItem>
                      <FormItem>
                        {getFieldDecorator('confirm', {

                          rules: [
                            { required: true, message: 'Please confirm your Password!' },
                            {
                              validator: this.compareToFirstPassword,
                            }],
                        })(
                          <Input type="password" placeholder="Confirm Password" autoComplete="new-password" name="confirm" onBlur={this.handleConfirmBlur} />
                        )}
                      </FormItem>
                      <FormItem>
                        <Button type="primary" className="gx-mb-0" htmlType="submit">
                          Submit
                    </Button>
                      </FormItem>
                    </Form> :
                    //log in
                    this.state.sms === false && this.state.forget_password === false ?
                      (<Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0" autoComplete="off">

                        <FormItem>
                          {getFieldDecorator('username', {
                            initialValue: '',
                            rules: [{
                              required: true, message: 'Please input your email address.',
                            }],
                          })(
                            <Input placeholder="Email" autoComplete="nope" name="email" />
                          )}
                        </FormItem>
                        <FormItem>
                          {getFieldDecorator('password', {

                            rules: [{ required: true, message: 'Please input your Password!' }],
                          })(
                            <Input type="password" placeholder="Password" name="password" autoComplete="new-password" />
                          )}
                        </FormItem>
                        <FormItem>
                          <Button type="primary" className="gx-mb-0" htmlType="submit">
                            <IntlMessages id="app.userAuth.signIn" />
                          </Button>
                          {/* eslint-disable-next-line */}
                          <a onClick={this.handleForgetPassword}>Forgot your password ?</a>
                          <br />
                          {/* eslint-disable-next-line */}
                          <a onClick={this.handleSignUp}>Request trial access</a>
                        </FormItem>
                      </Form>) :
                      //Log in with mfa code
                      this.state.sms === true && this.state.forget_password === false ? (
                        <Form onSubmit={this.SubmitSms} className="gx-signin-form gx-form-row0" autoComplete="off">
                          <FormItem>
                            {getFieldDecorator('code', {

                              rules: [{ required: true, message: 'Please input your code!' }],
                            })(
                              <Input placeholder="Code" autoComplete="nope" />
                            )}
                          </FormItem>
                          <FormItem>
                            <Button type="primary" className="gx-mb-0" htmlType="submit">
                              Submit
                      </Button>
                            <Button disabled={this.state.resend} type="primary" className="gx-mb-0" onClick={this.ResendConfirmationCode}>
                              {this.state.resend ? "Resend in " + this.state.yztime + " s" : "Resend"}
                            </Button>
                          </FormItem>
                        </Form>
                      ) :
                        //forgot password reset password
                        this.state.sms === false && this.state.forget_password === true && this.state.forget_password_send_email === true ?
                          (<Form onSubmit={this.handleSubmitResetPassword} className="gx-signin-form gx-form-row0" autoComplete="off">

                            <FormItem>
                              {getFieldDecorator('username', {
                                initialValue: '',
                                rules: [{
                                  required: true, message: 'Please input your email address.',
                                }],
                              })(
                                <Input placeholder="Email" autoComplete="nope" />
                              )}
                            </FormItem>
                            <FormItem>
                              {getFieldDecorator('code', {
                                initialValue: '',
                                rules: [{
                                  required: true, message: 'Please input your code.',
                                }],
                              })(
                                <Input placeholder="Code" autoComplete="nope" />
                              )}
                            </FormItem>
                            <FormItem>
                              {getFieldDecorator('password', {
                                rules: [
                                  {
                                    required: true, message: 'Please input your Password!'
                                  },
                                  {
                                    validator: this.validateToNextPassword,
                                  },],
                              })(
                                <Input type="password" placeholder="New Password" autoComplete="new-password" />
                              )}
                            </FormItem>
                            <FormItem>
                              {getFieldDecorator('confirm', {

                                rules: [
                                  {
                                    required: true, message: 'Please confirm your Password!'
                                  },
                                  {
                                    validator: this.compareToFirstPassword,
                                  },],
                              })(
                                <Input type="password" placeholder="Confirm Password" autoComplete="new-password" onBlur={this.handleConfirmBlur} />
                              )}
                            </FormItem>
                            <FormItem>
                              <Button type="primary" className="gx-mb-0" htmlType="submit">
                                Submit
                    </Button>
                            </FormItem>
                          </Form>) : (// forgot password enter email
                            <Form onSubmit={this.SubmitUserEmail} className="gx-signin-form gx-form-row0" autoComplete="off">
                              <FormItem label="Enter you email">
                                {getFieldDecorator('email', {

                                  rules: [{ required: true, message: 'Please input your email!' }],
                                })(
                                  <Input placeholder="Email" autoComplete="nope" />
                                )}
                              </FormItem>
                              <FormItem>
                                <Button type="primary" className="gx-mb-0" htmlType="submit">
                                  Submit
                              </Button>
                                {/* eslint-disable-next-line */}
                                <a onClick={this.ReturnSignIn}>Sign In</a>
                              </FormItem>
                            </Form>
                          )}
              </div>
              <InfoView />
              <SignUp
                visible={this.state.signup_visible}
                onClose={this.CloseSignUp}
                onSubmit={this.SubmitSignUp}
                wrappedComponentRef={this.wrapSignUpFormRef}
              />
            </div>
          </div>
        </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(SignInCognito);

const mapStateToProps = ({ auth }) => {
  const { access_token } = auth;
  return { access_token }
};

export default connect(mapStateToProps, { userSignInAws, ActionSingUp })(WrappedNormalLoginForm);